import {useFormikContext} from 'formik';

export const ResourceFormikBridge = ({registerFormik}: {registerFormik: (values: any, helpers: any) => void}) => {
  const {values, resetForm, setValues} = useFormikContext();
  registerFormik(values, {resetForm, setValues});
  return null;
};
